<template>
  <v-flex xs12 class="mt-5" data-cy="system-emails">
    <v-divider class="mb-4"></v-divider>
    <h2 class="primary--text pb-2">System emails</h2>
    <p>Customise the subject and layout of emails Caseblocks sends for this account. These templates are only available to account administrators.</p>
    <v-alert :value="!!error" type="error" class="mt-3">{{ error }}</v-alert>
    <v-progress-circular v-if="loading" indeterminate color="primary" class="mt-3"></v-progress-circular>
    <v-layout
      v-else
      mt-3 row wrap fluid
      class="script-card-container card-margin-fix">
      <v-flex
        v-for="template in templates"
        :key="template.key"
        xs12 md6 lg4 xl3 px-2 mb-2>
        <v-card class="px-4 py-3 rounded-3 elevation-2">
          <router-link class="no-link-style" :to="{ name: 'SystemEmailTemplate', params: { email_id: template.id } }">
            <h3 class="primary--text mb-1">{{ template.title }}</h3>
            <p class="mb-1">{{ template.description }}</p>
            <span class="body-1 opacity-54">{{ template.subject }}</span>
          </router-link>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: "system-emails",
  data: () => ({
    templates: [],
    loading: false,
    error: ""
  }),
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      this.error = ""
      try {
        this.templates = await this.$store.dispatch("systemEmailTemplates")
      } catch (error) {
        this.error = "Unable to load system emails."
      }
      this.loading = false
    }
  }
}
</script>
